import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Toggler from "../Toggler";
import styles from "./NotificationSettingsItem.module.css";

export function NotificationSettingsItem({ label, on, view }) {
  const [isToggled, setIsToggled] = useState(on);
  const toggleBackgroundColor = view === "IBO" ? "#415364" : "#7F6A45";

  useEffect(() => {
    setIsToggled(on);
  }, [on]);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  return (
    <div className={styles.container}>
      <div className={styles.togglerContainer}>
        <p className={styles.label}>{label}</p>
        <Toggler
          onChange={handleToggle}
          color={toggleBackgroundColor}
          toggled={isToggled}
        />
      </div>
    </div>
  );
}

NotificationSettingsItem.propTypes = {
  on: PropTypes.bool,
  label: PropTypes.string,
  view: PropTypes.string,
};
